import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { AssetPromo, ServiceType } from "@framework/shared";

export const promoRoutes: Array<RouteObject> = [
  {
    path: "/promos",
    element: <Protected />,
    children: [
      { index: true, element: <AssetPromo service={ServiceType.ADMIN} /> },
      { path: "/promos/:id", element: <AssetPromo service={ServiceType.ADMIN} /> },
    ],
  },
];
